export default __webpack_public_path__ + "static/media/9.42bb25c2.jpg";